// Regla de contraseñas del sistema (seguridad, tanda 5 — decidida por Ricardo 2026-10-03):
// mínimo 8 caracteres, con al menos una letra y al menos un número.
// La MISMA regla vive en el servidor (functions/api/admin-usuarios.js) y en Supabase
// (Authentication → Policies: largo 8 + "letras y números"): las tres deben coincidir.
export const REGLA_CLAVE = 'mínimo 8 caracteres, con letras y números';

// Devuelve el problema en palabras del usuario, o '' si la contraseña cumple.
export function problemaClave(p) {
  const s = String(p || '');
  if (s.length < 8) return 'La contraseña debe tener al menos 8 caracteres.';
  if (!/[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]/.test(s)) return 'La contraseña debe incluir al menos una letra.';
  if (!/[0-9]/.test(s)) return 'La contraseña debe incluir al menos un número.';
  return '';
}
